var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal modal-collection modal-collection-add",
      attrs: {
        id: "modal-search-report",
        tabindex: "-1",
        "aria-hidden": "true",
      },
    },
    [
      _c(
        "div",
        { staticClass: "modal-dialog modal-dialog-scrollable modal-xl" },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("div", { staticClass: "elements-left" }, [
                _c("h5", {
                  staticClass: "modal-title",
                  staticStyle: { position: "unset" },
                  domProps: {
                    textContent: _vm._s(_vm.$t("collection.addCollection")),
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "go-help-area" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "dropdown-menu dropdown-menu-cener" },
                    [
                      _c("div", { staticClass: "go-help-panel" }, [
                        _c("div", { staticClass: "panel-body" }, [
                          _c("div", {
                            staticClass: "help-gorup",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("collection.help.addCollection.div1")
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "help-gorup",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("collection.help.addCollection.div2")
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "help-gorup",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("collection.help.addCollection.div3")
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "help-gorup",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("collection.help.addCollection.div4")
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "help-gorup",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("collection.help.addCollection.div5")
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _vm._m(1),
                      ]),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _vm._m(2),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-body", staticStyle: { height: "100%" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "tab-pane fade show active",
                    staticStyle: { height: "100%" },
                    attrs: { id: "report-add-search" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "lc-panel lc-panel-collection-add" },
                      [
                        _c("div", { staticClass: "panel-header" }, [
                          _c("div", { staticClass: "panel-title" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("newLearningCenter.webSearch"))
                            ),
                            _c("small", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("collection.inforText.webSearch")
                                ),
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "go-help-area" }, [
                            _vm._m(3),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "dropdown-menu dropdown-menu-right",
                              },
                              [
                                _c("div", { staticClass: "go-help-panel" }, [
                                  _c("div", { staticClass: "panel-body" }, [
                                    _c("div", { staticClass: "help-gorup" }, [
                                      _c(
                                        "div",
                                        { staticClass: "help-group-title" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "collection.help.addCollection.webSearch.title"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "ol",
                                        { staticClass: "list-style-number" },
                                        [
                                          _c("li", [
                                            _c("span", { staticClass: "num" }, [
                                              _vm._v("1"),
                                            ]),
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "collection.help.addCollection.webSearch.step1"
                                                )
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _c("span", { staticClass: "num" }, [
                                              _vm._v("2"),
                                            ]),
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "collection.help.addCollection.webSearch.step2"
                                                )
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _c("span", { staticClass: "num" }, [
                                              _vm._v("3"),
                                            ]),
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "collection.help.addCollection.webSearch.step3"
                                                )
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _c("span", { staticClass: "num" }, [
                                              _vm._v("4"),
                                            ]),
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "collection.help.addCollection.webSearch.step4"
                                                )
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("li", [
                                            _c("span", { staticClass: "num" }, [
                                              _vm._v("5"),
                                            ]),
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "collection.help.addCollection.webSearch.step5"
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _vm._m(4),
                                ]),
                              ]
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "panel-body" }, [
                          _c("div", { staticClass: "add-input-area" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.language,
                                    expression: "language",
                                  },
                                ],
                                staticClass: "form-control",
                                staticStyle: {
                                  width: "6rem",
                                  height: "auto",
                                  "margin-right": "1px",
                                },
                                attrs: {
                                  disabled: _vm.selectedItems.length > 0,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.language = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                },
                              },
                              _vm._l(_vm.languages, function (value, key) {
                                return _c(
                                  "option",
                                  {
                                    key: "language-setting-" + key,
                                    domProps: { value: key },
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(value.name) +
                                        "\n                  "
                                    ),
                                  ]
                                )
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "input-group-reset input-group-search",
                              },
                              [
                                !_vm.isShowSpinner
                                  ? _c("i", {
                                      staticClass: "icon-common-lg icon-search",
                                    })
                                  : _c("b-spinner", {
                                      staticClass: "spinderCustom",
                                      attrs: {
                                        variant: "primary",
                                        label: "Spinning",
                                      },
                                    }),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.queries,
                                      expression: "queries",
                                    },
                                  ],
                                  staticClass: "form-control input-reset",
                                  attrs: {
                                    type: "search",
                                    placeholder: _vm.$t(
                                      "newLearningCenter.enterYourKeywords"
                                    ),
                                    maxlength: "2048",
                                  },
                                  domProps: { value: _vm.queries },
                                  on: {
                                    keydown: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      $event.preventDefault()
                                      _vm.onEnterSearch(),
                                        (_vm.isAddCondition = true)
                                    },
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.queries = $event.target.value
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _vm.queries
                                  ? _c(
                                      "button",
                                      {
                                        staticClass: "btn-reset",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            _vm.queries = ""
                                          },
                                        },
                                      },
                                      [
                                        _c("span", { staticClass: "hidden" }, [
                                          _vm._v("초기화"),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "lc-list-tap" }, [
                            _c(
                              "ul",
                              { staticClass: "nav nav-filter-type" },
                              _vm._l(_vm.tabs, function (tab) {
                                return _c(
                                  "li",
                                  {
                                    key: tab.name,
                                    staticClass: "nav-item",
                                    on: {
                                      click: function ($event) {
                                        return _vm.activeTab(
                                          tab.value,
                                          tab.searchType
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        class: [
                                          "nav-link",
                                          {
                                            active: _vm.tabActive === tab.value,
                                          },
                                        ],
                                        attrs: { "data-toggle": "tab" },
                                      },
                                      [_vm._v(_vm._s(tab.name))]
                                    ),
                                  ]
                                )
                              }),
                              0
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "lc-list-wrap" },
                            [
                              _c(
                                "vue-custom-scrollbar",
                                {
                                  staticClass:
                                    "list-inner overflow-y-scroll customScroll csScrollPosition ps",
                                  attrs: { settings: _vm.scrollSettings },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        overflow: "hidden",
                                        width: "auto",
                                        height: "auto",
                                      },
                                    },
                                    [
                                      _c(
                                        "ul",
                                        { staticClass: "lc-card-list" },
                                        [
                                          _vm._l(
                                            _vm.allData,
                                            function (item, index) {
                                              return _c(
                                                "li",
                                                {
                                                  key: index,
                                                  staticClass: "lc-card-item",
                                                  attrs: {
                                                    "aria-selected":
                                                      _vm.selectedItems.indexOf(
                                                        item
                                                      ) > -1
                                                        ? "true"
                                                        : "false",
                                                  },
                                                },
                                                [
                                                  _c("single-card", {
                                                    attrs: {
                                                      document: item,
                                                      selectedItems:
                                                        _vm.selectedItems,
                                                      isGoPage: true,
                                                    },
                                                    on: {
                                                      setSelectedItems:
                                                        _vm.setSelectedItems,
                                                      removeCardInList:
                                                        _vm.removeCardInList,
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          _vm._v(" "),
                                          _vm.isMoreResults
                                            ? _c(
                                                "li",
                                                {
                                                  staticClass: "lc-card-item",
                                                  attrs: {
                                                    "aria-selected": "false",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "item-wrap",
                                                      staticStyle: {
                                                        "text-align": "center",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "connected-keyword",
                                                          style: _vm.isShowMore
                                                            ? {
                                                                margin:
                                                                  "15% auto",
                                                              }
                                                            : {},
                                                        },
                                                        [
                                                          _vm.isShowMore
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "no-content",
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "bi bi-search",
                                                                  }),
                                                                  _vm._v(" "),
                                                                  _vm.isShowMore
                                                                    ? _c(
                                                                        "a",
                                                                        {
                                                                          staticClass:
                                                                            "active",
                                                                          staticStyle:
                                                                            {
                                                                              "border-color":
                                                                                "#e2e2e2",
                                                                              "font-size":
                                                                                "0.85rem",
                                                                              color:
                                                                                "#e2e2e2",
                                                                              "border-radius":
                                                                                "4px",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Loading..."
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                ]
                                                              )
                                                            : _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "no-content",
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "bi bi-search",
                                                                  }),
                                                                  _vm._v(" "),
                                                                  _c("strong", {
                                                                    domProps: {
                                                                      textContent:
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "feed.no-content.no-results"
                                                                          )
                                                                        ),
                                                                    },
                                                                  }),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "b-button",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          "margin-top":
                                                                            "15px",
                                                                          color:
                                                                            "#0097f6",
                                                                        },
                                                                      attrs: {
                                                                        variant:
                                                                          "light",
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          _vm.showMore,
                                                                      },
                                                                    },
                                                                    [
                                                                      _c("b", [
                                                                        _vm._v(
                                                                          "Show more"
                                                                        ),
                                                                      ]),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        2
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-footer", staticStyle: { "z-index": "10" } },
              [
                _c("div", { staticClass: "add-selected" }, [
                  _c("div", { staticClass: "top-bar" }, [
                    _c("div", { staticClass: "elements-left" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-add-selected-open",
                          attrs: {
                            type: "button",
                            "data-toggle": "collapse",
                            "data-target": "#add-selected",
                            "aria-expanded": "false",
                          },
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$t("newLearningCenter.selectedDocuments")
                              )
                          ),
                          _c("small", [
                            _vm._v(
                              "(" + _vm._s(_vm.selectedItems.length) + ")"
                            ),
                          ]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "elements-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          attrs: {
                            type: "button",
                            disabled:
                              _vm.isShowSpinner ||
                              _vm.selectedItems.length <= 0,
                          },
                          on: { click: _vm.addToReference },
                        },
                        [
                          _vm.isShowSpinner
                            ? _c("b-spinner", {
                                staticStyle: { width: "1rem", height: "1rem" },
                                attrs: { type: "grow", label: "Spinning" },
                              })
                            : _vm._e(),
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("newLearningCenter.add")) +
                              "\n              "
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "collapse add-selected-collapse",
                      attrs: { id: "add-selected" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "card card-body",
                          staticStyle: { "min-height": "180px" },
                        },
                        [
                          _c("div", { staticClass: "lc-list-wrap" }, [
                            _c(
                              "div",
                              {
                                staticClass: "list-inner overflow-x-scroll",
                                staticStyle: { width: "100%" },
                              },
                              [
                                _c(
                                  "vue-custom-scrollbar",
                                  {
                                    staticClass:
                                      "overflow-xy-scroll csScrollPositon",
                                    staticStyle: { width: "100%" },
                                    attrs: { settings: _vm.scrollSettings },
                                  },
                                  [
                                    _c(
                                      "ul",
                                      {
                                        staticClass: "lc-card-list",
                                        attrs: {
                                          id: "scroll-div-report-search",
                                        },
                                      },
                                      _vm._l(
                                        _vm.selectedItems,
                                        function (model, index) {
                                          return _c(
                                            "li",
                                            {
                                              key: index,
                                              staticClass: "lc-card-item",
                                              attrs: {
                                                "aria-selected": "false",
                                              },
                                            },
                                            [
                                              _c("single-card", {
                                                attrs: {
                                                  document: model,
                                                  isShowDelete: true,
                                                  isHideCheck: true,
                                                },
                                                on: {
                                                  removeCardReq:
                                                    _vm.removeCardReq,
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-prev",
                              attrs: { type: "button", id: "next" },
                              on: { click: _vm.nextAndPre },
                            },
                            [
                              _c("i", {
                                staticClass: "icon-common icon-arrow-left",
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-next",
                              attrs: { type: "button", id: "prev" },
                              on: {
                                click: function ($event) {
                                  return _vm.nextAndPre(true)
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "icon-common icon-arrow-right",
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn btn-help",
        attrs: {
          type: "button",
          "data-toggle": "dropdown",
          "aria-expanded": "false",
        },
      },
      [_c("i", { staticClass: "icon-common-lg icon-info" })]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      { staticClass: "btn btn-close", attrs: { type: "button" } },
      [_c("i", { staticClass: "icon-common icon-close" })]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "elements-right" }, [
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close",
          },
        },
        [_c("i", { staticClass: "icon-common-lg icon-close" })]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn btn-help",
        attrs: { type: "button", "data-toggle": "dropdown" },
      },
      [_c("i", { staticClass: "icon-common-lg icon-info" })]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      { staticClass: "btn btn-close", attrs: { type: "button" } },
      [_c("i", { staticClass: "icon-common icon-close" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }